export const Sidebardata = [
  {
    title: "Home",
    icon: <i className="fas fa-home  " />,
    link: "/dashboard",
  },
  {
    title: "Create Customer Account",
    icon: <i className="fas fa-user  " />,
    link: "/customer_account/create",
  },
  {
    title: "Create Policy",
    icon: <i className="fas fa-clipboard " />,
    link: "/policy/create",
  },
  {
    title: "Cancel Policy",
    icon: <i className="fas fa-ban " />,
    link: "/policy/cancel",
  },
  {
    title: "File Claim",
    icon: <i className="fas fa-money-bill " />,
    link: "/claim/create",
  },
  {
    title: "Search Customer Account",
    icon: <i className="fas fa-search  " />,
    link: "/customer_account/search",
  },
  {
    title: "Search Policy",
    icon: <i className="fas fa-clipboard-user " />,
    link: "/policy/search",
  },
  {
    title: "Search Claim",
    icon: <i className="fas fa-magnifying-glass-dollar  " />,
    link: "/claim/search",
  },
  {
    title: "Logout",
    icon: <i className="fas fa-right-from-bracket  " />,
    link: "/",
  },
];
